import React, { useMemo, useState } from 'react';
import {
  Alert,
  KeyboardAvoidingView,
  LogBox,
  Platform,
  Pressable,
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  View,
} from 'react-native';
import {callApi} from '../Helper/Helper';
//import CountryPicker from 'react-native-country-picker-modal';
import { CountryPicker } from 'react-native-country-codes-picker';

//import { CountryPicker } from "react-native-country-codes-picker";
import { useNavigation, useRoute } from '@react-navigation/native';
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
const ENDPOINT_URL = 'https://api.eabu.net';



export default function ProviderAdvertiseForm({ onSubmit }) {
  React.useEffect(() => {
    LogBox.ignoreLogs(['InteractionManager has been deprecated']);
  }, []);
  const [currentStep, setCurrentStep] = useState(0);
  const [address, setAddress] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [street, setStreet] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [phone, setPhone] = useState('');
  const [subtitle, setSubtitle] = useState('');
  const [country, setCountry] = useState('United States');
  const [title, setTitle] = useState('');
  const [url, setUrl] = useState('');
  const [description, setDescription] = useState('');
  const [zipcode, setZipcode] = useState('');
  const [countryCode, setCountryCode] = useState('US');
  const [callingCode, setCallingCode] = useState('1');
  const navigation = useNavigation();
  const [touched, setTouched] = useState({
    name: false,
    email: false,
    phone: false,
    description: false,
  });

  const handleSelectCountry = (country) => {
    const cca2 = country?.cca2 || 'US';
    const firstCalling =
        Array.isArray(country?.callingCode) && country.callingCode.length > 0
            ? country.callingCode[0]
            : callingCode;

    setCountryCode(cca2);
    setCallingCode(firstCalling);
    setCountry(country?.name || '');
  };

  const [submitting, setSubmitting] = useState(false);


  const phoneDigits = useMemo(() => phone.replace(/[^\d]/g, ''), [phone]);

  const errors = useMemo(() => {
    const e = {};
    if (!name.trim()) e.name = 'Name is required.';
    if (!email.trim()) e.email = 'Email is required.';
    else if (!EMAIL_RE.test(email.trim())) e.email = 'Enter a valid email.';
    if (!phone.trim()) e.phone = 'Phone number is required.';
    else if (phoneDigits.length < 7) e.phone = 'Enter a valid phone number.';
    if (!description.trim()) e.description = 'Description is required.';
    else if (description.length > 250) e.description = 'Description must be 250 characters max.';
    return e;
  }, [name, email, phone, phoneDigits.length, description]);

  const isValid = Object.keys(errors).length === 0;

  const handleBlur = (field) => {
    setTouched((prev) => ({ ...prev, [field]: true }));
  };

  const handleNext = () => {
    if (currentStep === 0) {
      // Validate Contact Info
      setTouched((prev) => ({ ...prev, name: true, email: true, phone: true }));
      if (errors.name || errors.email || errors.phone) {
        Alert.alert('Required Fields', 'Please correct the errors in the contact information before proceeding.');
        return;
      }
      if (!name || !email || !phone) {
         Alert.alert('Required Fields', 'Please fill in all contact fields.');
         return;
      }

    } else if (currentStep === 2) {
      // Validate Ad Content (Description is required)
      setTouched((prev) => ({ ...prev, description: true }));
      if (errors.description) {
         Alert.alert('Required Fields', 'Please correct the description.');
         return;
      }
      if (!description) {
        Alert.alert('Required Fields', 'Description is required.');
        return;
      }
    }

    setCurrentStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setCurrentStep((prev) => prev - 1);
  };

    const handleSubmit = async (path) => {
        setTouched({ name: true, email: true, phone: true, description: true });
        if (!isValid) return;

        setSubmitting(true);
        try {
            const endpoint = `${ENDPOINT_URL}${path}`;
            const finalAddress = address.trim() || [street, city, state, country, zipcode].filter(p => p && p.trim()).join(', ');

            const e164Phone = phoneDigits ? `+${callingCode}${phoneDigits}` : '';
            const payload = {
                address: finalAddress,
                zipcode: zipcode.trim(),
                country: country.trim(),
                name: name.trim(),
                email: email.trim(),
                phone: e164Phone,
                subtitle: subtitle,
                title : title,
                url: url?.trim(),
                status: "pending",
                description: description.trim(),
                submittedAt: new Date().toISOString(),
            };

            const res = await callApi('POST', endpoint, { body: payload })


            // Optionally clear the form on success
            setCurrentStep(0); // Reset to start
            setName('');
            setEmail('');
            setPhone('');
            setDescription('');
            setZipcode('');
            setTouched({
                name: false,
                email: false,
                phone: false,
                description: false,
            });
            Alert.alert(
                  'Request Received!',
                  'Thank you for submitting your request. Our team will review it and contact you within 2-3 business days.',
                  [{ text: 'OK', onPress: () => navigation.navigate('Home') }]
                );
            } catch (err) {
                console.error('Failed to submit advertise form:', err);
            } finally {
            setSubmitting(false);
        }
    };



  return (
    <KeyboardAvoidingView
      behavior={Platform.select({ ios: 'padding', android: undefined })}
      style={styles.flex}
    >
      <ScrollView
        contentContainerStyle={styles.container}
        keyboardShouldPersistTaps="handled"
      >
        <Text style={styles.title}>Advertise With Us</Text>

        {/* --- STEP 1: CONTACT INFO --- */}
        {currentStep === 0 && (
          <View>
            <Text style={styles.sectionHeader}>Step 1: Contact Information</Text>
            <View style={styles.field}>
              <Text style={styles.label}>Name</Text>
              <TextInput
                value={name}
                onChangeText={setName}
                onBlur={() => handleBlur('name')}
                placeholder="Your full name"
                autoCapitalize="words"
                autoCorrect={false}
                style={[styles.input, touched.name && errors.name ? styles.inputError : null]}
                accessibilityLabel="Name"
                returnKeyType="next"
              />
              {touched.name && errors.name ? <Text style={styles.error}>{errors.name}</Text> : null}
            </View>

            <View style={styles.field}>
              <Text style={styles.label}>Email</Text>
              <TextInput
                value={email}
                onChangeText={setEmail}
                onBlur={() => handleBlur('email')}
                placeholder="you@example.com"
                keyboardType="email-address"
                autoCapitalize="none"
                autoCorrect={false}
                style={[styles.input, touched.email && errors.email ? styles.inputError : null]}
                accessibilityLabel="Email"
                returnKeyType="next"
              />
              {touched.email && errors.email ? <Text style={styles.error}>{errors.email}</Text> : null}
            </View>

            <Text style={{ marginTop: 12, marginBottom: 6, color: '#374151' }}>Phone</Text>
            <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 12 }}>
              <CountryPicker
                withFilter
                withFlag
                withCallingCode
                countryCode={countryCode}
                onSelect={handleSelectCountry}
                containerButtonStyle={{ paddingVertical: 8, paddingRight: 8 }}
              />
              <TextInput
                style={{
                  width: 90,
                  height: 44,
                  borderWidth: 1,
                  borderColor: '#ccc',
                  borderRadius: 8,
                  paddingHorizontal: 10,
                }}
                keyboardType="phone-pad"
                placeholder="+Country code"
                value={`+${callingCode}`}
                editable={false}
              />
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <TextInput
                  value={phone}
                  onChangeText={(text) => {
                    const digits = String(text).replace(/\D/g, '').slice(0, 15);
                    setPhone(digits);
                  }}
                  placeholder="Phone number"
                  keyboardType="phone-pad"
                  returnKeyType="next"
                  maxLength={15}
                  style={{
                    flex: 1,
                    borderWidth: 1,
                    borderColor: '#D1D5DB',
                    borderRadius: 8,
                    paddingHorizontal: 12,
                    paddingVertical: 10,
                  }}
                  accessibilityLabel="Phone number input"
                />
              </View>
            </View>
            {touched.phone && errors.phone ? <Text style={styles.error}>{errors.phone}</Text> : null}
          </View>
        )}

        {/* --- STEP 2: LOCATION --- */}
        {currentStep === 1 && (
          <View>
            <Text style={styles.sectionHeader}>Step 2: Location Details</Text>


            <View style={styles.field}>
              <Text style={styles.label}>Street</Text>
              <TextInput
                value={street}
                onChangeText={setStreet}
                placeholder="Street Address"
                autoCapitalize="words"
                autoCorrect={false}
                style={styles.input}
              />
            </View>

            <View style={styles.field}>
              <Text style={styles.label}>City</Text>
              <TextInput
                value={city}
                onChangeText={setCity}
                placeholder="City"
                autoCapitalize="words"
                autoCorrect={false}
                style={styles.input}
              />
            </View>

            <View style={styles.field}>
              <Text style={styles.label}>State</Text>
              <TextInput
                value={state}
                onChangeText={setState}
                placeholder="State"
                autoCapitalize="characters"
                autoCorrect={false}
                style={styles.input}
              />
            </View>
            <View style={styles.field}>
              <Text style={{ marginTop: 12, marginBottom: 6, color: '#374151' }}>ZIP code (Where you want to advertise)</Text>
              <TextInput
                value={zipcode}
                onChangeText={setZipcode}
                placeholder="ZIP code"
                autoCorrect={false}
                autoCapitalize="none"
                textContentType="postalCode"
                returnKeyType="next"
                maxLength={10}
                style={styles.input}
                accessibilityLabel="ZIP code input"
              />
            </View>
          </View>
        )}

        {/* --- STEP 3: AD DETAILS --- */}
        {currentStep === 2 && (
          <View>
            <Text style={styles.sectionHeader}>Step 3: Ad Content</Text>
            <View style={styles.field}>
              <Text style={styles.label}>Title</Text>
              <TextInput
                value={title}
                onChangeText={(t) => setTitle(t.slice(0, 100))}
                onBlur={() => handleBlur('title')}
                placeholder="Title for your advertisement"
                maxLength={100}
                style={styles.input}
                accessibilityLabel="Title"
              />
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>SubTitle</Text>
              <TextInput
                value={subtitle}
                onChangeText={(t) => setSubtitle(t.slice(0, 150))}
                onBlur={() => handleBlur('subtitle')}
                placeholder="Sub-title your advertisement"
                maxLength={150}
                style={styles.input}
                accessibilityLabel="Subtitle"
              />
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>URL</Text>
              <TextInput
                value={url}
                onChangeText={(t) => setUrl(t.slice(0, 200))}
                onBlur={() => handleBlur('url')}
                placeholder="url of your business"
                maxLength={200}
                style={styles.input}
                accessibilityLabel="URL"
              />
            </View>
            <View style={styles.field}>
              <Text style={styles.label}>Description</Text>
              <TextInput
                value={description}
                onChangeText={(t) => setDescription(t.slice(0, 250))}
                onBlur={() => handleBlur('description')}
                placeholder="Briefly describe your advertisement..."
                multiline
                maxLength={250}
                style={[
                  styles.input,
                  styles.textarea,
                  touched.description && errors.description ? styles.inputError : null,
                ]}
                accessibilityLabel="Description"
              />
              <View style={styles.counterRow}>
                <Text style={styles.counter}>{description.length}/250</Text>
              </View>
              {touched.description && errors.description ? (
                <Text style={styles.error}>{errors.description}</Text>
                  ) : null}
                </View>
              </View>
            )}

            {/* --- STEP 4: REVIEW --- */}
            {currentStep === 3 && (
              <View>
                <Text style={styles.sectionHeader}>Step 4: Review & Submit</Text>

                <View style={styles.reviewItem}>

                <Text style={styles.reviewLabel}>Email</Text>
                <Text style={styles.reviewValue}>{email}</Text>
            </View>
            <View style={styles.reviewItem}>
                <Text style={styles.reviewLabel}>Phone</Text>
                <Text style={styles.reviewValue}>+{callingCode} {phone}</Text>
            </View>
            <View style={styles.reviewItem}>
                <Text style={styles.reviewLabel}>Address</Text>
                <Text style={styles.reviewValue}>{address || [street, city, state, country, zipcode].filter(p => p && p.trim()).join(', ') || 'N/A'}</Text>

            </View>

            <View style={styles.reviewItem}>
                <Text style={styles.reviewLabel}>Title</Text>
                <Text style={styles.reviewValue}>{title || 'N/A'}</Text>
            </View>
            <View style={styles.reviewItem}>
              <Text style={styles.reviewLabel}>Sub-Title</Text>
              <Text style={styles.reviewValue}>{subtitle || 'N/A'}</Text>
            </View>
             <View style={styles.reviewItem}>
                <Text style={styles.reviewLabel}>Description</Text>
                <Text style={styles.reviewValue}>{description}</Text>
            </View>


            <Pressable
              onPress={() => handleSubmit('/eabu-ad')}
              disabled={!isValid || submitting}
              style={({ pressed }) => [
                styles.button,
                (!isValid || submitting) && styles.buttonDisabled,
                pressed && !submitting && isValid ? styles.buttonPressed : null,
              ]}
              accessibilityRole="button"
              accessibilityState={{ disabled: !isValid || submitting }}
            >
              <Text style={styles.buttonText}>{submitting ? 'Submitting…' : 'Confirm & Submit'}</Text>
            </Pressable>
          </View>
        )}

        {/* --- NAVIGATION BUTTONS --- */}
        <View style={styles.navContainer}>
            {currentStep > 0 && currentStep < 4 ? (
                 <Pressable onPress={handleBack} style={styles.navButton}>
                     <Text style={styles.navButtonText}>Back</Text>
                 </Pressable>
            ) : <View />}

            {currentStep < 3 && (
                 <Pressable onPress={handleNext} style={[styles.button, styles.navNextButton]}>
                     <Text style={styles.buttonText}>Next</Text>
                 </Pressable>
            )}
        </View>

      </ScrollView>
    </KeyboardAvoidingView>
  );
}

const styles = StyleSheet.create({
  flex: { flex: 1, backgroundColor: '#fff' },
  container: {
    padding: 16,
    paddingBottom: 32,
  },
  title: {
    fontSize: 22,
    fontWeight: '700',
    marginBottom: 16,
    color: '#0d47a1',
    textAlign: 'center',
  },
  sectionHeader: {
    fontSize: 18,
    fontWeight: '600',
    color: '#546e7a',
    marginBottom: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    paddingBottom: 8,
  },
  navContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  navButton: {
    paddingVertical: 14,
    paddingHorizontal: 24,
    borderRadius: 10,
    backgroundColor: '#cfd8dc',
    alignItems: 'center',
  },
  navNextButton: {
    marginTop: 0,
    minWidth: 100,
  },
  navButtonText: {
    color: '#374151',
    fontSize: 16,
    fontWeight: '600',
  },
  reviewItem: {
    marginBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
    paddingBottom: 8,
  },
  reviewLabel: {
    fontSize: 12,
    color: '#90a4ae',
    textTransform: 'uppercase',
    marginBottom: 2,
  },
  reviewValue: {
    fontSize: 16,
    color: '#263238',
  },
  field: { marginBottom: 14 },
  label: { fontSize: 14, marginBottom: 6, color: '#333' },
  input: {
    borderWidth: 1,
    borderColor: '#cfd8dc',
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 10,
    fontSize: 16,
    backgroundColor: '#fafafa',
    color: '#111',
  },
  dropdownList: {
    borderWidth: 1,
    borderColor: '#cfd8dc',
    borderTopWidth: 0,
    borderRadius: 8,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    backgroundColor: '#fff',
    marginTop: -5,
  },
  dropdownItem: {
    paddingHorizontal: 12,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },
  textarea: {
    minHeight: 96,
    textAlignVertical: 'top',
  },
  inputError: {
    borderColor: '#e53935',
    backgroundColor: '#fff6f6',
  },
  error: {
    color: '#e53935',
    fontSize: 12,
    marginTop: 6,
  },
  counterRow: {
    marginTop: 6,
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  counter: {
    fontSize: 12,
    color: '#607d8b',
  },
  button: {
    marginTop: 8,
    backgroundColor: '#0d47a1',
    paddingVertical: 14,
    borderRadius: 10,
    alignItems: 'center',
  },
  buttonPressed: { opacity: 0.9 },
  buttonDisabled: { backgroundColor: '#90a4ae' },
  buttonText: { color: '#fff', fontSize: 16, fontWeight: '700' },
});
